import script from "./StudentWrongQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentWrongQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./StudentWrongQuestion.vue?vue&type=style&index=0&id=b4f2838e&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4f2838e"]])

export default __exports__